import { render, staticRenderFns } from "./RecaptchaDisclosure.vue?vue&type=template&id=3e705e49&"
import script from "./RecaptchaDisclosure.vue?vue&type=script&lang=ts&"
export * from "./RecaptchaDisclosure.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e705e49')) {
      api.createRecord('3e705e49', component.options)
    } else {
      api.reload('3e705e49', component.options)
    }
    module.hot.accept("./RecaptchaDisclosure.vue?vue&type=template&id=3e705e49&", function () {
      api.rerender('3e705e49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/recaptcha/RecaptchaDisclosure.vue"
export default component.exports